<template>
  <div class="container">
    <QueryFrame
      customed-text="导出Excel"
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      @handleCustomed='exportExcel'
      :count= 'count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>客户:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.pharCustomerName"></lk-input>
          </div>
          <div class="queryItem">
            <label>订单号:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model="query.saleOrderCode"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="gotoHandleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import toolsService from '../../../services/lgq/services';

export default {
  name: 'saleOrderList',
  mixins: [mapState, queryMixins],
  data() {
    return {
      size: 20,
      query: {
        pharCustomerName: '',
        saleOrderCode: '',
      },
      columns: [
        { title: '客户名称', key: 'companyName', minWidth: 116 },
        { title: '订单号', key: 'orderCode', minWidth: 116 },
        { title: '订单状态', key: 'statusName', minWidth: 116 },
        { title: '物流单号', key: 'deliverNo', minWidth: 116 },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)),
        },
        { title: '订单金额', key: 'amount', minWidth: 116 },
        { title: '联系人', key: 'pharCustomerName', minWidth: 116 },
        { title: '联系电话', key: 'pharCustomerPhone', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          // fixed: 'right',
          width: 140,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'saleOrderInfoEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑'),
            ![1, 4].includes(params.row.status) && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'saleOrderInfoEditRefund', params: { id: params.row.id } });
                },
              },
            }, '退货'),
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'saleOrderInfo', params: { id: params.row.id } });
                },
              },
            }, '查看'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    exportExcel() {
      toolsService.exportOrderList({
        pharCustomerName: this.query.pharCustomerName,
        saleOrderCode: this.query.saleOrderCode,
      }).then((res) => {
        if (res.status === 200) {
          utils.downFile(res.data, `销售订单列表${utils.formatTime(new Date().getTime(), 'YYYYMMDD')}.xlsx`);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      toolsService.saleOrderList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list;
          this.count = res.data.data.count || 0;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoHandleSearch() {
      this.handleSearch();
    },
    clear() {
      this.query = {
        pharCustomerName: '',
        saleOrderCode: '',
      };
    },
  },
  mounted() {
    this.handleSearch(true);
  },
  components: {
    QueryFrame,
  },
};
</script>

<style scoped>
</style>
